<template>
    <div class="row legend">
        <div class="col-3 legend--label">Legende</div>
        <div class="col-3 icons--age">Leeftijd</div>
        <div class="col-3 icons--operations">Werking</div>
        <div class="col-3 icons--district">Wijk</div>
    </div>
</template>

<script>
    export default {
      name: 'EntityListLegend'
    }
</script>

<style scoped>
.legend {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-bottom: 2px solid rgba(53, 90, 140, .2);
}

.row.legend {
    margin: 0;
    height: 75px;
    padding-left: 20px;
}

@media all and (min-width: 992px) {
    .row.legend {
        padding-left: 0;
        height: auto;
    }
}

.row.legend .col-3 {
    font-size: 13px;
    background-size: 25px;
    background-position: center left;
    padding: 0 0 0 35px;
    line-height: 75px;
    font-family: 'AndesBook', Helvetica, Arial, sans-serif;
}

.row.legend .legend--label {
    font-size: 13px;
    font-family: 'AndesBold', Helvetica, Arial, sans-serif;
    line-height: 75px;
    padding-left: 20px;
    text-transform: uppercase;
}

@media all and (min-width: 992px) {
    .row.legend .col-3 {
        line-height: 3em;
        padding-left: 35px;
        margin-left: 40px;
    }

    .row.legend .legend--label {
        line-height: 3em;
        padding-left: 0;
        margin-left: 40px;
    }

    .col-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

    .icons--age,
    .icons--operations {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
        margin: 0;
    }
}

@media all and (min-width: 1300px) {
    .row.legend .col-3 {
        line-height: 4em;
        padding-left: 35px;
        margin-left: 0;
    }

    .row.legend .legend--label {
        line-height: 4em;
        padding-left: 35px;
        margin-left: 0;
    }

    .col-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33%;
        flex: 0 0 33%;
        max-width: 33%;
    }

    .row.legend  .icons--district {
        margin-left: 33%;
        line-height: 4em;
    }
}

@media all and (min-width: 1600px) {
    .row.legend .col-3 {
        line-height: 75px;
        padding-left: 35px;
        margin-left: 0;
    }

    .row.legend .legend--label {
        line-height: 75px;
        padding-left: 35px;
        margin-left: 0;
    }

    .col-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .row.legend  .icons--district {
        margin-left: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/entities/Legend.vue